<template>
    <div class="all">
      <Head></Head>
      <div class="dingzhigengduo">
        <div class="dingzhigengduo_img">
          <img :src="classData.list_head_img1?$store.state.Url+classData.list_head_img1:img" alt="" v-if="classData.list_head_img1">
          <img :src="classData.list_head_img2?$store.state.Url+classData.list_head_img2:img" alt="" v-if="classData.list_head_img2">
          <div class="clear"></div>
        </div>
        <div v-for="(item,key) in List" :key="key">
          <div class="dingzhigengduo_text">
            <span>【{{item.name}}】</span>
          </div>
          <div class="dingzhigengduo_img">
            <img :src="item.two_img?$store.state.Url+item.two_img:img" alt="" v-if="item.two_img">
            <div class="clear"></div>
          </div>
          <div class="dingzhigengduo_shop">
            <div class="dingzhigengduo_shop_for" v-for="(i,index) in item.goods" :key="index">
              <div class="dingzhigengduo_shop_for_left">
                <img :src="i.goods_img?$store.state.Url+i.goods_img:img" alt="">
              </div>
              <div class="dingzhigengduo_shop_for_right">
                <div>
                  <button>{{i.goods_name}}</button>
                  <h5>品质有保证</h5>
                  <p>{{i.goods_name}}</p>
                  <span @click="$router.push({path:'/details',query:{id:i.goods_id,status:3}})">立即定制</span>
                </div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <Pagetail></Pagetail>
    </div>
</template>

<script>
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
  import img from '../assets/zanwu.png'
  import {getCustomliebiao} from '../api/index'
    export default {
        name: "dingzhigengduo",
      components: {
        Pagetail, Head
      },
      data(){
        return{
          List:[],
          classData:{},
          img:img
        }
      },
      mounted() {
        this.init()
      },
      methods:{
          init(){
            getCustomliebiao({
              id:this.$route.query.id
            }).then(res=>{
              this.List = res.two_class
              this.classData = res.class
            })
          }
      }
    }
</script>

<style scoped lang="less">
  @import "css/dingzhigengduo";
</style>



// WEBPACK FOOTER //
// src/components/dingzhigengduo.vue